// Base imports
import $ from 'jquery';
import 'bootstrap';
import Vue from 'vue';
import VeeValidate from 'vee-validate';

import './app/common';
import './app/pixel';

// Content specific imports
import './app/api';
import './app/faq';
import './app/product';
import './app/slider';
import './app/webview-product';

// Vue Components
//import './app/components/vc-cta-sign-up';
import './app/components/vc-cta';
import './app/components/vc-equalizer-animation';
import './app/components/vc-error';
import './app/custom-validation';
import './app/components/vc-submit-contest-form';

Vue.use(VeeValidate);
window.Vue = global.Vue = Vue;
window.VeeValidate = VeeValidate;
global.$ = global.jQuery = window.$ = window.jQuery = $;

var RVS = window.RVS || {};
RVS.Data = RVS.Data || {};


// WEBPACK FOOTER //
// ./Content/js/index.js